var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$ct("parcels-of-sale", {
                  saleNr: _vm.sale.ComputedFriendlyID,
                })
              ) +
              " "
          ),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.fetching
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [_c("w-progress-circular")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.parcels.length == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("no-parcels-found")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            _vm._l(_vm.parcels, function (item) {
              return _c(
                "w-list-item",
                {
                  key: item.ID,
                  on: {
                    click: function ($event) {
                      return _vm.openParcel(item)
                    },
                  },
                },
                [
                  _c("w-list-item-text", [
                    _vm._v(" " + _vm._s(item.ParcelID) + " "),
                  ]),
                ],
                1
              )
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }